import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import HotSection from './components/HotSection';
import StatsSection from './components/StatsSection';
import NewSection from './components/NewSection';
import FAQSection, { FAQStructuredData } from './components/FAQSection';
import HomePageSEO from './components/HomePageSEO';

export default function Home() {
  return (
    <>
      <HomePageSEO />
      <FAQStructuredData />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroBanner />
        <CategorySection />
        <FeaturedSection />
        <HotSection />
        <StatsSection />
        <NewSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}